import React from 'react'
import AgeGateContent from './AgeGateContent'

export default function AgeGatePage () {
  return (
    <div className='ageGatePage mobile'>
      <AgeGateContent isMobile={true} />
    </div>
  )
}
